"use client";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { usePageTitle } from "@/lib/usePageTitle";

const lastUpdated = "January 19, 2026";

export default function RefundPolicyPage() {
  usePageTitle("Refund Policy");
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Refund policy</h1>
            <p className="text-sm text-muted-foreground">Last updated: {lastUpdated}</p>
          </div>
          <div className="space-y-4 text-muted-foreground">
            <p>
              BlockyNetworks does not generally process refunds because access is provided digitally. Any refunds are
              offered only where required by applicable law.
            </p>
            <p>
              If you believe you were charged in error, contact support with your details so we can investigate and correct
              the issue.
            </p>
            <p>
              For help, email support@blockynetworks.com.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
